import {
  StarIcon as StarIconStrokeRounded,
  ArrowRight01StrokeRounded,
  PlayIcon as PlayIconStrokeRounded,
  PauseIcon as PauseIconStrokeRounded,
  Wrench01StrokeRounded,
  Plant01StrokeRounded,
  ToolsStrokeRounded,
  DropletStrokeRounded,
  PaintBrush02StrokeRounded,
  GarbageTruckStrokeRounded,
  ZapStrokeRounded,
  ComputerStrokeRounded,
  DeliveryTruck01StrokeRounded,
  Chair01StrokeRounded,
  CleanStrokeRounded,
  SparklesStrokeRounded,
  CreditCardStrokeRounded,
  KnightShieldStrokeRounded,
  Calendar01StrokeRounded,
  SmartPhone01StrokeRounded,
  FavouriteStrokeRounded,
  Package01StrokeRounded,
  Shield01StrokeRounded,
  SquareLockCheck01StrokeRounded,
  UserShield02StrokeRounded,
  SecurityCheckStrokeRounded,
  Cash02StrokeRounded,
  Cancel01StrokeRounded,
  Tick01StrokeRounded,
  Rocket01StrokeRounded,
  Globe02StrokeRounded,
  UserGroupStrokeRounded,
  ChartIncreaseStrokeRounded,
  Agreement02StrokeRounded,
  Clock01StrokeRounded,
  UserMultipleStrokeRounded,
  Building05StrokeRounded,
  CheckmarkCircleStrokeRounded,
  Shield02StrokeRounded,
  WalletStrokeRounded,
  TaskStrokeRounded,
  QuotesStrokeRounded,
  UserStarStrokeRounded,
  CrownStrokeRounded,
  Tick02StrokeRounded,
  LocationStrokeRounded,
  PlayCircleIcon as PlayCircleStrokeRounded,
  DashboardSquare01Icon as DashboardSquare01StrokeRounded,
  Tag01Icon as Tag01StrokeRounded,
  ArrowLeft01Icon as ArrowLeft01StrokeRounded,
  PackageMovingStrokeRounded,
  Leaf04StrokeRounded,
  WasteRestoreStrokeRounded,
  WashingMachineStrokeRounded,
  ElectricHome01StrokeRounded,
  Bathtub01StrokeRounded,
  FloorPlanStrokeRounded,
  GreenHouseStrokeRounded,
  PartyStrokeRounded,
  MoreHorizontalStrokeRounded,
  User02StrokeRounded,
} from '@hugeicons-pro/core-stroke-rounded';

import { StarIcon as StarIconSolidRounded } from '@hugeicons-pro/core-solid-rounded';

import type { IconSvgObject } from '@hugeicons/angular';

export type IconVariant = 'stroke' | 'solid' | 'auto';

type IconVariants = Partial<Record<IconVariant, IconSvgObject>>;

const icons = {
  star: {
    stroke: StarIconStrokeRounded,
    solid: StarIconSolidRounded,
  },
  'arrow-right-01': {
    stroke: ArrowRight01StrokeRounded,
  },
  play: {
    stroke: PlayIconStrokeRounded,
  },
  pause: {
    stroke: PauseIconStrokeRounded,
  },
  'wrench-01': {
    stroke: Wrench01StrokeRounded,
  },
  'plant-01': {
    stroke: Plant01StrokeRounded,
  },
  tools: {
    stroke: ToolsStrokeRounded,
  },
  droplet: {
    stroke: DropletStrokeRounded,
  },
  'paint-brush-02': {
    stroke: PaintBrush02StrokeRounded,
  },
  'garbage-truck': {
    stroke: GarbageTruckStrokeRounded,
  },
  zap: {
    stroke: ZapStrokeRounded,
  },
  computer: {
    stroke: ComputerStrokeRounded,
  },
  'delivery-truck-01': {
    stroke: DeliveryTruck01StrokeRounded,
  },
  'chair-01': {
    stroke: Chair01StrokeRounded,
  },
  clean: {
    stroke: CleanStrokeRounded,
  },
  sparkles: {
    stroke: SparklesStrokeRounded,
  },
  'credit-card': {
    stroke: CreditCardStrokeRounded,
  },
  'knight-shield': {
    stroke: KnightShieldStrokeRounded,
  },
  'calendar-01': {
    stroke: Calendar01StrokeRounded,
  },
  'smart-phone-01': {
    stroke: SmartPhone01StrokeRounded,
  },
  favourite: {
    stroke: FavouriteStrokeRounded,
  },
  'package-01': {
    stroke: Package01StrokeRounded,
  },
  'shield-01': {
    stroke: Shield01StrokeRounded,
  },
  'square-lock-check-01': {
    stroke: SquareLockCheck01StrokeRounded,
  },
  'user-shield-02': {
    stroke: UserShield02StrokeRounded,
  },
  'security-check': {
    stroke: SecurityCheckStrokeRounded,
  },
  'cash-02': {
    stroke: Cash02StrokeRounded,
  },
  'cancel-01': {
    stroke: Cancel01StrokeRounded,
  },
  'tick-01': {
    stroke: Tick01StrokeRounded,
  },
  'rocket-01': {
    stroke: Rocket01StrokeRounded,
  },
  'globe-02': {
    stroke: Globe02StrokeRounded,
  },
  'user-group': {
    stroke: UserGroupStrokeRounded,
  },
  'chart-increase': {
    stroke: ChartIncreaseStrokeRounded,
  },
  'agreement-02': {
    stroke: Agreement02StrokeRounded,
  },
  'clock-01': {
    stroke: Clock01StrokeRounded,
  },
  'user-multiple': {
    stroke: UserMultipleStrokeRounded,
  },
  'building-05': {
    stroke: Building05StrokeRounded,
  },
  'checkmark-circle': {
    stroke: CheckmarkCircleStrokeRounded,
  },
  'shield-02': {
    stroke: Shield02StrokeRounded,
  },
  wallet: {
    stroke: WalletStrokeRounded,
  },
  task: {
    stroke: TaskStrokeRounded,
  },
  quote: {
    stroke: QuotesStrokeRounded,
  },
  'user-star': {
    stroke: UserStarStrokeRounded,
  },
  crown: {
    stroke: CrownStrokeRounded,
  },
  'tick-02': {
    stroke: Tick02StrokeRounded,
  },
  location: {
    stroke: LocationStrokeRounded,
  },
  'play-circle': {
    stroke: PlayCircleStrokeRounded,
  },
  'dashboard-square-01': {
    stroke: DashboardSquare01StrokeRounded,
  },
  'tag-01': {
    stroke: Tag01StrokeRounded,
  },
  'arrow-left-01': {
    stroke: ArrowLeft01StrokeRounded,
  },
  'package-moving': {
    stroke: PackageMovingStrokeRounded,
  },
  'leaf-04': {
    stroke: Leaf04StrokeRounded,
  },
  'waste-restore': {
    stroke: WasteRestoreStrokeRounded,
  },
  'washing-machine': {
    stroke: WashingMachineStrokeRounded,
  },
  'electric-home-01': {
    stroke: ElectricHome01StrokeRounded,
  },
  'bathtub-01': {
    stroke: Bathtub01StrokeRounded,
  },
  'floor-plan': {
    stroke: FloorPlanStrokeRounded,
  },
  'green-house': {
    stroke: GreenHouseStrokeRounded,
  },
  party: {
    stroke: PartyStrokeRounded,
  },
  'more-horizontal': {
    stroke: MoreHorizontalStrokeRounded,
  },
  'user-02': {
    stroke: User02StrokeRounded,
  },
} as const satisfies Record<string, IconVariants>;

export type IconName = keyof typeof icons;

export function resolveIcon(
  name: IconName,
  variant: IconVariant,
): IconSvgObject {
  const fallback = icons['star'].stroke;

  const icon = icons[name];
  const resolvedVariant = variant !== 'auto' ? variant : 'stroke';

  if (!icon) {
    return fallback;
  }

  return (icon as IconVariants)[resolvedVariant] ?? fallback;
}

/** Narrows a name from data (e.g. an API field) to a registered icon. */
export function isIconName(name: string | null | undefined): name is IconName {
  return !!name && Object.prototype.hasOwnProperty.call(icons, name);
}
